import React from 'react';
import contacts from '../data/contacts.json';

const ContactsScreen = ({ darkMode }) => {
  return (
    <>
      <h2 className={`text-xl font-bold mb-4 ${darkMode ? 'text-white' : ''}`}>Контакты</h2>

      <div className={`rounded-lg shadow p-4 mb-4 ${darkMode ? 'bg-gray-800 text-white' : 'bg-white'
        }`}>
        <div className="flex justify-center mb-4">
          <img
            src={contacts.logo}
            alt="Логотип"
            className="h-16"
          />
        </div>

        <div className="mb-4">
          <h3 className={`font-semibold mb-2 ${darkMode ? 'text-white' : ''}`}>Телефоны</h3>
          <p className={darkMode ? 'text-gray-300' : 'text-gray-600'}>
            {contacts.phone.map((phone, index) => (
              <a key={index} href={`tel:${phone}`} className="text-blue-500 block mb-1">{phone}</a>
            ))}
          </p>
        </div>

        <div className="mb-4">
          <h3 className={`font-semibold mb-2 ${darkMode ? 'text-white' : ''}`}>Адрес</h3>
          <p className={darkMode ? 'text-gray-300' : 'text-gray-600'}>
            <strong>{contacts.address.city}, {contacts.address.street}</strong>
          </p>
        </div>

        <div className="mb-4">
          <h3 className={`font-semibold mb-2 ${darkMode ? 'text-white' : ''}`}>Часы работы</h3>
          <p className={darkMode ? 'text-gray-300' : 'text-gray-600'}>
            <strong>{contacts.workHours.weekdays.days}:</strong> {contacts.workHours.weekdays.hours}<br />
            <strong>{contacts.workHours.weekend.days}:</strong> {contacts.workHours.weekend.hours}
          </p>
        </div>

        <div className="mb-4">
          <h3 className={`font-semibold mb-2 ${darkMode ? 'text-white' : ''}`}>Email</h3>
          <p className={darkMode ? 'text-gray-300' : 'text-gray-600'}>
            <a href={`mailto:${contacts.email}`} className="text-blue-500">{contacts.email}</a>
          </p>
        </div>

        {contacts.description && (
          <div className="mb-4">
            <h3 className={`font-semibold mb-2 ${darkMode ? 'text-white' : ''}`}>О нас</h3>
            <div
              className={darkMode ? 'text-gray-300' : 'text-gray-600'}
              dangerouslySetInnerHTML={{ __html: contacts.description }}
            ></div>
          </div>
        )}
      </div>
      {/*
      <div className={`rounded-lg shadow p-4 mb-4 ${darkMode ? 'bg-gray-800 text-white' : 'bg-white'
        }`}>
        <h3 className={`font-semibold mb-2 ${darkMode ? 'text-white' : ''}`}>Наш магазин</h3>
        <img
          src={contacts.shopPhoto}
          alt="Фото магазина"
          className="w-full h-auto rounded-lg mb-4"
        />
      </div>*/}

      <div className={`rounded-lg shadow p-4 ${darkMode ? 'bg-gray-800 text-white' : 'bg-white'
        }`}>
        <h3 className={`font-semibold mb-2 ${darkMode ? 'text-white' : ''}`}>Как нас найти</h3>
        <div className="w-full h-64 rounded-lg overflow-hidden">
          <iframe
            src={contacts.mapUrl}
            width="100%"
            height="100%"
            frameBorder="0"
            title="Карта"
            className="rounded-lg"
          ></iframe>
        </div>
      </div>
    </>
  );
};

export default ContactsScreen;